import React from "react"
import { view } from "react-easy-state"
import { deserialise } from "kitsu-core"
import { withRouter } from "react-router-dom"
import axios from "axios"
import MicRecorder from "mic-recorder-to-mp3"
import { Button, Modal, Form, Icon, Input, Select, Upload, message, Avatar } from "antd"

import globalStore from "store"
import { API, getAuthorization } from "api"
import Lightbox from "components/common/Lightbox/Index"
import MiniPlayer from "components/common/MiniPlayer/Index"
import CoursesService from "services/students/courses.service"

const Mp3Recorder = new MicRecorder({ bitRate: 128 })
class AskDoubt extends React.Component {
  state = {
    modalVisible: false,
    fileList: [],
    submitting: false,
    courses: [],
    subscribedCourses: [],
    chapters: [],
    modalContentLoading: false,
    isRecording: false,
    recordings: [],
    isBlocked: false,
    selectedRecording: null,
  }

  componentDidMount() {
    // !this.props.hideSubjectInput && this.fetchData();
  }

  async fetchData() {
    const pageState = globalStore.ui.students.courses.askdoubt
    await CoursesService.index({ pageState })

    const { subscribed_courses } = pageState

    if (subscribed_courses) {
      this.setState({ subscribedCourses: subscribed_courses })
    }
  }

  handleSubjectChange = (selected) => {
    const [courseId, subjectId] = selected.split("-")
    const { subscribedCourses } = this.state

    const course = subscribedCourses.find((course) => course.id === parseInt(courseId))

    if (!course) {
      this.setState({ chapters: [] })
      return
    }

    const subject = course.subjects.find((s) => s.id === parseInt(subjectId))

    if (!subject) {
      this.setState({ chapters: [] })
      return
    }

    this.setState({ chapters: subject.chapters })
  }

  handleSaveDoubt = () => {
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const { fileList, recordings } = this.state
        const formData = new FormData()

        this.setState({ submitting: true })

        fileList &&
          fileList.forEach((file) => {
            formData.append("files[]", file)
          })

        recordings &&
          recordings.forEach((r) => {
            formData.append("files[]", r.blob, `doubt-audio-recorded-${r.timestamp}`)
          })

        Object.keys(values).forEach((key) => {
          if (["subject_id", "chapter_id"].includes(key)) {
            formData.append(key, values[key].split("-")[1])
          } else {
            formData.append(key, values[key])
          }
        })

        const { videoId, chapterId, questionId, doubt } = this.props

        if (videoId) {
          formData.append("video_id", videoId)
        }
        if (chapterId) {
          formData.append("chapter_id", chapterId)
        }
        if (questionId) {
          formData.append("question_id", questionId)
        }

        if (doubt) {
          axios
            .put(`${process.env.REACT_APP_API_BASE_URL}/${API.students.doubts.index.url}/${doubt.id}`, formData, {
              headers: {
                Authorization: getAuthorization(),
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              const responseData = response.data

              this.handleResponse(responseData, "edit")
            })
            .catch((e) => {
              console.error("Error", e)
              this.setState({
                submitting: false,
              })
              message.destroy()
              message.error("Couldn't update.")
            })
          return
        }

        axios
          .post(`${process.env.REACT_APP_API_BASE_URL}/${API.students.doubts.create.url}`, formData, {
            headers: {
              Authorization: getAuthorization(),
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            const responseData = response.data
            this.handleResponse(responseData, "create")
          })
          .catch((e) => {
            console.error("Error", e)
            this.setState({
              submitting: false,
            })
            message.destroy()
            message.error("Couldn't update.")
          })
      }
    })
  }

  handleResponse = async (responseData, action) => {
    const deserialisedData = await deserialise(responseData.doubt)

    if (!deserialisedData.data) {
      this.setState({
        submitting: false,
      })
      message.destroy()
      message.error("Something went wrong.")
      return
    }

    if (action === "edit") {
      globalStore.ui.students.doubts.show.doubt = deserialisedData.data
    }

    this.setState({
      submitting: false,
      fileList: [],
      recordings: [],
      modalVisible: false,
      selectedRecording: null,
    })
    this.props.form.resetFields()
    message.destroy()
    message.success("Your doubt is submitted successfully.")
  }

  renderAttachments = (doubt) => {
    const attachedFiles = doubt.attached_files

    const images = attachedFiles.filter((f) => f.contentType.includes("image"))

    const audios = attachedFiles.filter((f) => f.contentType.includes("audio"))

    return (
      <div style={{ display: "flex" }}>
        <Lightbox images={images} doubtId={doubt.id} deletable={true} />
        <MiniPlayer audios={audios} doubtId={doubt.id} deletable={true} />
      </div>
    )
  }

  openModal = async () => {
    this.setState({ modalVisible: true })

    if (!this.props.hideSubjectInput) {
      this.setState({ modalContentLoading: true })
      await this.fetchData()
      this.setState({ modalContentLoading: false })
    }
  }

  startRecording = () => {
    navigator.getUserMedia(
      { audio: true },
      () => {
        console.log("Permission Granted")
        this.setState({ isBlocked: false })
        Mp3Recorder.start()
          .then(() => {
            this.setState({ isRecording: true })
          })
          .catch((e) => console.error(e))
      },
      () => {
        console.log("Permission Denied")
        this.setState({ isBlocked: true })
      },
    )
  }

  stopRecording = () => {
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const { recordings } = this.state

        const blobURL = URL.createObjectURL(blob)

        this.setState({ isRecording: false, recordings: [...recordings, { blob, blobURL, timestamp: Date.now() }] })
      })
      .catch((e) => console.log(e))
  }

  playRecording = (recording) => {
    this.setState({ selectedRecording: recording })
  }

  deleteRecording = (recording) => {
    const { recordings } = this.state

    const filteredRecordings = recordings.filter((r) => r.timestamp !== recording.timestamp)

    this.setState({ recordings: filteredRecordings })

    message.destroy()
    message.success("Recorded audio is deleted successfully.")
  }

  renderThumbnails = () => {
    const { selectedRecording, recordings } = this.state

    return (
      <div className="miniplayer-thumbnails" style={{ marginTop: 10 }}>
        {recordings.map((recording, i) => (
          <div className="deletable-item" key={`audio-${i}`}>
            <div key={i} className="miniplayer-thumbnail" onClick={(e) => this.playRecording(recording, e)}>
              <Avatar
                style={{
                  backgroundColor: "#b9b9b9",
                }}
                shape="square"
                size={64}
              />
              <Icon
                type={
                  selectedRecording && selectedRecording.timestamp === recording.timestamp
                    ? "pause-circle"
                    : "play-circle"
                }
              />
            </div>
            <div className="delete-icon" onClick={() => this.deleteRecording(recording)}>
              <Icon type="delete" />
            </div>
          </div>
        ))}
      </div>
    )
  }

  renderForm = () => {
    const { fileList, modalContentLoading } = this.state
    const {
      form: { getFieldDecorator },
      doubt,
    } = this.props

    const uploadProps = {
      multiple: true,
      onRemove: (file) => {
        this.setState((state) => {
          const index = state.fileList.indexOf(file)
          const newFileList = state.fileList.slice()
          newFileList.splice(index, 1)
          return {
            fileList: newFileList,
          }
        })
      },
      beforeUpload: (file) => {
        this.setState((state) => ({
          fileList: [...state.fileList, file],
        }))
        return false
      },
      fileList,
    }

    if (modalContentLoading) {
      return (
        <div className="modal-content-loading">
          <Icon type="loading" />
        </div>
      )
    }

    return (
      <Form className="doubt-form">
        {this.renderSubjectInput()}
        <Form.Item label="Your doubt">
          {getFieldDecorator("description", {
            rules: [{ required: true, message: "Please write your doubt!" }],
            initialValue: doubt && doubt.description,
          })(<Input.TextArea rows={4} />)}
        </Form.Item>

        {this.renderExistingAttachments()}
        <Upload.Dragger {...uploadProps}>
          <p className="ant-upload-drag-icon">
            <Icon type="inbox" />
          </p>
          <p className="ant-upload-text">Click or drag an audio or image file to this area to upload</p>
          <p className="ant-upload-hint">
            Support for a single or bulk upload. Strictly prohibit from uploading company data or other band files
          </p>
        </Upload.Dragger>
        <div style={{ marginTop: 30 }}>
          {this.renderRecordingButton()}
          {this.renderThumbnails()}
          {this.renderAudioPlayer()}
        </div>
      </Form>
    )
  }

  renderAudioPlayer = () => {
    const { selectedRecording } = this.state

    if (!selectedRecording) return null

    return (
      <div className="audio-modal">
        <div className="audio-player">
          <audio controls autoPlay="autoplay">
            <source src={selectedRecording.blobURL} />
            Your browser does not support the audio element.
          </audio>
          <h3>{`${selectedRecording.timestamp}`}</h3>
          <Button
            type="primary"
            shape="circle"
            icon="close"
            onClick={() => this.setState({ selectedRecording: null })}
          />
        </div>
      </div>
    )
  }

  renderSubjectInput = () => {
    const { subscribedCourses, chapters } = this.state
    const {
      hideSubjectInput,
      form: { getFieldDecorator },
    } = this.props

    if (hideSubjectInput) return null
    return (
      <React.Fragment>
        <Form.Item label="Subject">
          {getFieldDecorator("subject_id", {
            rules: [{ required: true, message: "Please select subject!" }],
          })(
            <Select placeholder="Select Subject" onChange={this.handleSubjectChange}>
              {subscribedCourses.map((course) => (
                <Select.OptGroup label={course.name} key={`course-${course.id}`}>
                  {course.subjects.map((s) => (
                    <Select.Option value={`${course.id}-${s.id}`} key={`subject-${s.id}`}>
                      {s.name}
                    </Select.Option>
                  ))}
                </Select.OptGroup>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item label="Chapter">
          {getFieldDecorator("chapter_id", {
            rules: [{ required: true, message: "Please select chapter!" }],
          })(
            <Select placeholder="Select Chapter">
              {chapters.map((c) => (
                <Select.Option value={`chapter-${c.id}`} key={c.id}>
                  {c.name}
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
      </React.Fragment>
    )
  }

  renderRecordingButton = () => {
    const { isRecording } = this.state

    if (isRecording) {
      return (
        <Button type="primary" block onClick={this.stopRecording}>
          <Icon type="stop" /> Stop Recording
        </Button>
      )
    }

    return (
      <Button block onClick={this.startRecording}>
        <Icon type="audio" /> Start Recording
      </Button>
    )
  }

  renderExistingAttachments = () => {
    const { doubt } = this.props

    if (!doubt) return null

    if (doubt.attached_files.length === 0) return null

    return <Form.Item label="Previously attached files">{this.renderAttachments(doubt)}</Form.Item>
  }

  render() {
    const { modalVisible, submitting, modalContentLoading } = this.state

    return (
      <div className="ask-doubt-wrapper">
        <div className="ask-doubt-button" style={this.props.buttonStyle || {}}>
          <Button type={this.props.buttonType || "primary"} onClick={this.openModal}>
            {this.props.buttonText || "Ask a doubt"}
          </Button>
        </div>
        <Modal
          title="Ask a doubt"
          visible={modalVisible}
          style={{ top: 20 }}
          confirmLoading={submitting || modalContentLoading}
          okText="Submit"
          onOk={this.handleSaveDoubt}
          onCancel={() => this.setState({ modalVisible: false })}
        >
          {this.renderForm()}
        </Modal>
      </div>
    )
  }
}

AskDoubt = Form.create({ name: "doubt-form" })(AskDoubt)

export default withRouter(view(AskDoubt))
